import { palette } from '@centivo/react-components'
import styled, { css } from 'styled-components'

export const SearchForm = styled.form`
  align-items: start;
  justify-content: space-between;

  div.name-search {
    input {
      max-height: 3.125rem;
      padding-left: 2.55rem;
    }

    > p > span {
      color: #444b55;
    }

    > div {
      > label {
        color: ${palette.brand.gray};
      }

      > div {
        color: ${palette.brand.brown};
      }
    }
  }

  .search-bar__form-input.centivo--select__value-container.centivo--select__wrapper {
    padding: 0px;
  }
  .centivo--select__value-container {
    padding: 2px 0 8px 8px;
  }

  .search-bar__form-input,
  .border--second-child {
    color: ${palette.brand.darkGray};

    > p {
      color: #444b55;
    }

    > div > div > div {
      border-color: ${palette.brand.lightGray};

      label {
        color: ${palette.brand.gray};
      }

      > div > svg {
        color: ${palette.brand.brown};
      }
    }
  }

  ${({ theme }) => {
    switch (theme.template) {
      case 'template-4':
        return css`
          .zip-search .centivo--select__menu * {
            overflow-y: hidden;
          }

          .search-bar__form-input,
          .centivo--select__control,
          .centivo--select__input-container {
            font-size: 0.875rem;
            font-weight: 400;

            input.name-search.search-bar__form-input--input {
              height: 50px;
              :focus {
                border-color: ${theme.palette.brand.newPurple};
              }
            }

            label,
            input,
            > p,
            .centivo--select__single-value {
              font-weight: 400;
            }

            input,
            .centivo--select__single-value {
              color: ${theme.palette.brand.darkGray};
            }

            label {
              max-width: calc(100% - 2.75rem);
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;

              color: ${theme.palette.brand.gray};
            }

            div span {
              color: #444b55;
            }

            @media (min-width: 1500px) {
              font-size: 1rem;
            }
          }

          .centivo--select__option--is-focused {
            background: #f7f4e6;
            border: 1px solid ${theme.palette.brand.darkGreen};
          }

          .centivo--select__option--is-selected {
            background: #f7f4e6;
          }

          .centivo--select__control,
          .search-bar__form-input input {
            border-color: ${theme.palette.brand.lightGray};
            border-radius: 10px;
          }

          .centivo--select__wrapper.error {
            .centivo--select__control {
              border-color: ${theme.palette.ui.error};
            }
          }
        `
      default:
        return css`
          > div:not(:last-child):not(:nth-last-child(2)) {
            margin-bottom: 1.5rem;
          }

          > div:nth-last-child(2) {
            margin-bottom: 2rem;
          }

          .search-bar__form-input,
          .centivo--select__control,
          .centivo--select__input-container {
            font-size: 0.875rem;
            font-weight: 400;

            input.name-search.search-bar__form-input--input {
              height: 50px;
              :focus {
                border-color: ${theme.palette.brand.newPurple};
              }
            }

            label,
            input,
            > p,
            .centivo--select__single-value {
              font-weight: 400;
            }

            input,
            .centivo--select__single-value {
              color: ${theme.palette.brand.darkGray};
            }

            label {
              max-width: calc(100% - 2.75rem);
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;

              color: ${theme.palette.brand.gray};
            }

            div span {
              color: #444b55;
            }

            @media (min-width: 1500px) {
              font-size: 1rem;
            }
          }

          .centivo--select__option--is-focused {
            background: #f7f4e6;
            border: 1px solid ${theme.palette.brand.darkGreen};
          }

          .centivo--select__option--is-selected {
            background: #f7f4e6;
          }

          .centivo--select__control,
          .search-bar__form-input input {
            border-color: ${theme.palette.brand.lightGray};
            border-radius: 10px;
          }

          .centivo--select__wrapper.error {
            .centivo--select__control {
              border-color: ${theme.palette.ui.error};
            }
          }
        `
    }
  }}

  .submit-search {
    width: 210px;
    display: block;
    margin: 0 auto;
    font-size: 1.125rem;
    font-weight: 500;
    border-radius: 10px;
    background-color: ${palette.brand.orange};
    color: #44190a;
    :focus {
      box-shadow: ${palette.brand.newPurple} inset 0px 0px 0px 1px,
        #fff inset 0px 0px 0px 2px !important;
    }

    :hover {
      background-color: rgba(255, 118, 71, 0.8);
      box-shadow: none !important;
    }
  }

  @media ${({ theme }) => theme.mediaQueries.desktop} {
    display: grid;

    ${({ theme }) => {
      switch (theme.template) {
        case 'template-4':
          return css`
            grid-template-columns: 28.8% 28.8% 18.5% 18.5%;
          `

        default:
          return css`
            grid-template-columns: 28% 27% 20% 18%;
          `
      }
    }}

    div.name-search,
    div.zip-search,
    > div:not(:last-child) {
      margin-bottom: unset;
    }

    .submit-search {
      width: unset;
      margin: unset;
    }
  }

  @media ${({ theme }) => theme.mediaQueries.mobile} {
    .submit-search {
      margin-bottom: 14px;
      width: 100%;
    }
  }

  @media ${({ theme }) => theme.mediaQueries.ipadPro} {
    .submit-search {
      margin-bottom: 14px;
      width: 100%;
    }
  }

  @media ${({ theme }) => theme.mediaQueries.tablet} {
    .submit-search {
      margin-bottom: 14px;
      width: 100%;
    }
  }

  .category-doctor--select.border--second-child--select {
    .centivo--select__menu-list {
      .centivo--select__option:nth-child(2) {
        border-bottom: 1px
          ${({ theme }) => theme.palette.neutral['grey-d8d8d8']} solid;
      }
    }
  }

  ${({ theme }) => {
    switch (theme.template) {
      case 'template-4':
        return css`
          @media ${theme.mediaQueries.desktop} {
            > div:not(:last-child):not(:nth-last-child(2)) {
              margin-bottom: 0rem !important;
            }

            > div:nth-last-child(2) {
              margin-bottom: 0rem !important;
            }
          }

          > div:not(:last-child):not(:nth-last-child(2)) {
            margin-bottom: 1.25rem;
          }

          > div:nth-last-child(2) {
            margin-bottom: 1.25rem;
          }

          .name-search,
          .zip-search,
          .category-doctor,
          .category-facility {
            * {
              font-weight: 400;
            }

            .icon-centivo--slice-cancel {
              color: ${theme.palette.brand.lightGray};
            }

            .icon-centivo--alert-circle {
              color: ${theme.palette.ui.error};
            }
          }

          input.zip-search {
            padding-left: 0.75rem !important;
          }

          .centivo--select__menu {
            overflow: hidden;
            border-radius: 10px;

            box-shadow: none;
            border-style: solid;
            border-width: 1px;
            border-color: ${theme.palette.brand.lightGray};
          }

          .centivo--select__menu-list {
            overflow-x: hidden;
            overflow-y: scroll;

            padding: 0.5rem 0 0.75rem 0;

            div {
              padding: 0.531rem 0.75rem 0.531rem 0.75rem;

              font-weight: 400;
              color: ${theme.palette.brand.darkGray};
              font-size: 1rem;
              line-height: 1.44rem;
            }
          }
        `

      default:
        return {}
    }
  }}
`
